import { getFormedEltTranslationForKeys } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslationForKeys'
import { TUpdateELTFormData } from 'legacy/lut/components/widgets/public/partner360/ELT/models/common'
import {
  TImagesFields,
  TMergedImages,
} from 'legacy/lut/components/widgets/public/partner360/ELT/models/ImageUpload'
import { Preview } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/companyImageUploader/Preview'
import { Title } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/title/Title'
import { DragNDropFileUploader } from 'legacy/lut/library/dragNDrop'
import { useCallback, useMemo } from 'react'

import { IFileSettings } from 'core-components/library/dragNDropFileUploader'

import { StockImageGuide } from './components/stockImageGuide/StockImageGuide'

import styles from './StockImage.module.scss'

interface IStockImageProps {
  onImageUpload: (fieldName: string, file: any, fileName: string) => void
  displayedImages: TMergedImages
  updateData: TUpdateELTFormData
  formIsFinalized: boolean
}

export const StockImage = ({
  onImageUpload,
  updateData,
  formIsFinalized,
  displayedImages,
}: IStockImageProps) => {
  const handlePictureChange = useCallback(
    (fieldName: TImagesFields) => (filesInfo: IFileSettings[]) => {
      onImageUpload(fieldName, filesInfo[0].file, filesInfo[0].file.name)
      updateData(fieldName, filesInfo[0].file.name)
    },
    [onImageUpload, updateData]
  )

  const onDelete = useCallback(
    (field: TImagesFields) => () => {
      updateData(field, '')
    },
    [updateData]
  )

  const preview = useMemo(() => {
    const preview = displayedImages['Attachment']
    return preview.src || preview.file
  }, [displayedImages])

  return (
    <div className={styles.root}>
      <Title
        variant="withBackground"
        text={getFormedEltTranslationForKeys('doc-stock-image-title')}
        rightContent={<StockImageGuide />}
        className={styles.title}
      />

      <div className={styles.wrapper}>
        {preview ? (
          <Preview
            src={preview}
            onDelete={onDelete('Attachment')}
            formIsFinalized={formIsFinalized}
            className={styles.img}
          />
        ) : (
          <DragNDropFileUploader
            disabled={formIsFinalized}
            className={styles.uploader}
            urlInputVisibility={false}
            fileListVisibility={false}
            changeFileLoader={handlePictureChange('Attachment')}
            acceptedFormats={'image/*'}
          />
        )}
      </div>
    </div>
  )
}
